module.exports = __webpack_public_path__ + "img/title_sp.bbda5b60.svg";